module.exports = __webpack_public_path__ + "img/slide1.b2f54168.png";